// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-dialog-form[data-v-75fecb9e]{width:100%;max-width:450px;border-radius:10px}.m-dialog-form__card[data-v-75fecb9e]{padding:30px 0 0}.m-dialog-form__footer[data-v-75fecb9e]{background:#f0f1f2;border-bottom-left-radius:10px;border-bottom-right-radius:10px;padding-top:22px;padding-bottom:22px}", ""]);
// Exports
module.exports = exports;
